import TngReportDetailDialog from "./tngReportDetailDialog.container";

export default TngReportDetailDialog;
